import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { createInstance } from '@jonkoops/matomo-tracker-react';

import type { Tracking } from '@izimi/core';
import { useCookieConsent } from '@izimi/core';

import PageTracker from './PageTracker';
import { useTrackingStore } from './trackingStore';

interface Props {
  config: Tracking | null;
  cookieUrl: string;
  children?: ReactNode;
  withPageTracker?: boolean;
}

const TrackingProvider = ({ children, config, cookieUrl, withPageTracker = true }: Props) => {
  const { setMatomoTracker } = useTrackingStore();
  const { preferences } = useCookieConsent(cookieUrl);

  const hasConsent = Boolean(
    preferences?.cookieOptions.find((opt) => opt.id === 'statistics')?.isEnabled,
  );

  useEffect(() => {
    if (config) {
      setMatomoTracker({
        matomoTracker: hasConsent
          ? createInstance({
              urlBase: config.url,
              siteId: config.siteId,
              trackerUrl: config.trackerUrl,
              srcUrl: config.srcUrl,
              userId: config.userId,
              heartBeat: {
                active: true,
                seconds: 30,
              },
              linkTracking: false,
            })
          : undefined,
      });
    }
  }, [config, hasConsent, setMatomoTracker]);

  return (
    <>
      {children}
      {withPageTracker && <PageTracker />}
    </>
  );
};

export default TrackingProvider;
